export default __webpack_public_path__ + "Background-02.png";